import { render } from "./Empty.vue?vue&type=template&id=bf2fedb6&scoped=true"
const script = {}

import "./Empty.vue?vue&type=style&index=0&id=bf2fedb6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf2fedb6"]])

export default __exports__